import ClipboardJS from 'clipboard';
import Tracking from './tracking';

const Copy = {
	trigger: '.btn--copy-text',
	Init() {
		Copy.Tooltip();
		Copy.CopyToClipboard();
	},
	Tooltip() {
		$(Copy.trigger)
			.tooltip({
				placement: 'top',
				title: 'Copied!',
				trigger: 'manual'
			})
			.on('mouseout', function hideTooltip() {
				$(this).tooltip('hide');
			});
	},
	CopyToClipboard() {
		const clipboard = new ClipboardJS(Copy.trigger);

		clipboard.on('success', e => {
			const $btn = $(e.trigger);
			Tracking.TrackEvent('Navigation', 'Copy Text', $btn.data('clipboard-target'));
			$btn.tooltip('show');
			setTimeout(() => {
				$btn.tooltip('hide');
			}, 2000);
		});
	}
};

export default Copy;
